import { createSlice } from "@reduxjs/toolkit";

const userSlice = createSlice({
  name: "user",
  initialState: {
    username: "",
  },
  reducers: {
    setUsername: (state, action) => {
      state.username = action.payload;
    },
  }
});

export const { setUsername } = userSlice.actions;

export const selectUsername = state => state.user.username;

export default userSlice.reducer;